import React from 'react';
import PropTypes from 'prop-types';

import './SectionTabMobileDropdown.scss';
import Arrow from '../../Arrow/Arrow';
import { commonMenuItemShape } from '../SectionTabHeader';

export default class SectionTabMobileDropdown extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
        this.scrollTimeout = null;
    }

    static propTypes = {
        /**
         * Array of dropdown menu items
         */
        dropdownItems: PropTypes.arrayOf(PropTypes.shape(commonMenuItemShape))
            .isRequired,
        dropdownTitle: PropTypes.string,
        renderMenuItem: PropTypes.func.isRequired,
    };

    static defaultProps = {
        dropdownTitle: 'Menu',
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('scroll', this.debounceScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    debounceScroll = () => {
        const that = this;
        clearTimeout(this.scrollTimeout);
        if (this.state.isDropdownOpen === true) {
            this.scrollTimeout = setTimeout(function () {
                that.setState({
                    isDropdownOpen: false,
                });
            }, 100);
        }
    };

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    handleClickOutside = (event) => {
        if (
            this.state.isDropdownOpen &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target)
        ) {
            this.setState({ isDropdownOpen: false });
        }
    };

    toggleDropdown = () => {
        this.setState((prevState) => {
            return { isDropdownOpen: !prevState.isDropdownOpen };
        });
    };

    render() {
        let showDropDownClass = this.state.isDropdownOpen ? 'open' : 'close';
        let showActive = this.state.isDropdownOpen ? 'active' : '';
        return (
            <div className="component-Elements-SectionTabHeader-SectionTabMobileDropdown bold">
                <div className="containingDiv" ref={this.setWrapperRef}>
                    <div
                        className={`title-section d-flex ${showActive}`}
                        onClick={this.toggleDropdown}
                    >
                        <span className="dropdown-title submenu-item w-100 w-md-auto d-flex">
                            <div className="arrow-offset d-md-none" />
                            {this.props.dropdownTitle}
                            <Arrow direction={showActive ? 'up' : 'down'} />
                        </span>
                    </div>
                    <ul className={`dropdown-content ${showDropDownClass}`}>
                        {this.state.isDropdownOpen &&
                            this.props.dropdownItems.map(
                                this.props.renderMenuItem
                            )}
                    </ul>
                </div>
            </div>
        );
    }
}
